import { Suspense } from 'react';
import {
  createBrowserRouter as baseCreateBrowserRouter,
  Outlet,
  RouteObject,
} from 'react-router-dom';

export interface BrowserRouterOptions {
  routes: RouteObject[];
  basename?: string;
  rootComponent?: React.ComponentType;
  errorElement?: React.ReactNode;
  fallback?: React.ReactNode;
}

export const createBrowserRouter = (opts?: BrowserRouterOptions) => {
  const {
    rootComponent: RootComponent = (({ children }) => children) as React.FC<{
      children?: React.ReactNode;
    }>,
    fallback = <div>Loading...</div>,
  } = { ...opts };

  const router = baseCreateBrowserRouter(
    [
      {
        element: (
          <RootComponent>
            <Suspense fallback={fallback}>
              <Outlet />
            </Suspense>
          </RootComponent>
        ),
        errorElement: opts?.errorElement,
        children: opts?.routes,
      },
    ],
    opts
  );

  return router;
};

export default createBrowserRouter;
